import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { LARGE_SCREEN_SIZE } from '../../mediaQueries.const';

export const sectionStyle = {
  maxWidth: `${LARGE_SCREEN_SIZE}px`,
  margin: '0 auto',
};

export const SectionTag: React.FunctionComponent = ({ children }) => {
  return (
    <section
      className={css(StyleSheet.create({ sectionStyle }).sectionStyle)}
    >
      {children}
    </section>
  );
};

export const Section = SectionTag;
